import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { ReactComponent as AutoFixIcon } from '@material-design-icons/svg/round/auto_fix_high.svg'
import Button from 'components/common/Button'
import TextInput from 'components/common/TextInput'
import c from './IdleStage.module.scss'

interface IdleStageProps {
  text: string
  onTextChange: (newText: string) => void
  onProcessingStart: () => void
}

function IdleStage({ text, onTextChange, onProcessingStart }: IdleStageProps) {
  const { t } = useTranslation()

  const handleTextChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onTextChange(e.target.value)
    },
    [onTextChange],
  )

  return (
    <>
      <div>
        <p className={c.heading}>{t('stages.generation.idle.inputLabel')}</p>
        <TextInput
          className={c.input}
          placeholder={t('stages.generation.idle.inputPlaceholder')}
          startIcon={<AutoFixIcon style={{ fill: 'currentColor' }} />}
          value={text}
          onChange={handleTextChange}
        />
      </div>
      <div className="bottom">
        <Button
          className={c.button}
          disabled={text.length === 0}
          onClick={onProcessingStart}
        >
          {t('stages.generation.idle.buttonText')}
        </Button>
      </div>
    </>
  )
}

export default IdleStage
